import React from 'react';
import SuccessContainer from '../../../../components/modules/Balance/Payment/Success/Index';

const PaymentSuccess = () => <SuccessContainer />;

export default PaymentSuccess;
